import React from 'react';
import classes from './ImportHomework.module.scss';
import { useTranslation } from 'react-i18next';
import Underconstraction from '../../01_atoms/Underconstraction';

const ImportHomework = () =>{
    const {t} = useTranslation();

    return(
        <div className={classes.commentContainer}>
            <Underconstraction/>
        </div>
    )
}

export default ImportHomework;